$(document).ready(function () {
  $(".brands-slick").slick({
    dots: false,
    infinite: false,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    mobileFirst: true,
    nextArrow:
      '<img src="https://cdn.shopify.com/s/files/1/0018/3166/5728/files/next.png?v=1688766392" class="slick-next">',
    prevArrow:
      '<img src="https://cdn.shopify.com/s/files/1/0018/3166/5728/files/next.png?v=1688766392" class="slick-prev">',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  $(".reviews-slider").slick({
    dots: true,
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  //**********search popup
  // $(".search-link").on("click", function (e) {
  //   e.preventDefault();
  //   $('[data-dropdown="search"]').show();
  // });
});
